import redirectTo from '../../loggedRedirectTo';

export const TYPE_ENUM = {
    link: 'LINK',
    action: 'ACTION',
};

export default [
    {
        name: 'Painel',
        pages: ['/site'],
        path: '/site',
        exact: true,
        type: TYPE_ENUM.link,
    },
    {
        name: 'Editar site',
        exact: true,
        type: TYPE_ENUM.action,
        action: redirectTo.sites,
    },
    {
        name: 'Fale conosco',
        pages: ['/site/ticket'],
        path: '/site/ticket',
        exact: true,
        type: TYPE_ENUM.link,
    },
];
